<template>
  <v-container
    id="register"
    class="fill-height justify-center"
    tag="section"
  >
    <!-- Modal des CGU -->
    <v-dialog
      v-model="displayCGU"
      width="70%"
      persistent
    >
      <v-card
        class="white secondary--text"
      >
        <v-card-title>
          <span class="headline">Conditions générales d'utilisation</span>
        </v-card-title>
        <v-card-text
          class="secondary--text"
        >
          <cgu />
        </v-card-text>
        <v-card-actions
          class="justify-center"
        >
          <v-btn
            color="primary"
            @click="displayCGU = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                <v-icon left>
                  mdi-view-dashboard
                </v-icon>
                Tableau de bord Happy Quest
                <v-icon right>
                  mdi-view-dashboard
                </v-icon>
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <div class="text-center grey--text body-1 font-weight-bold">
              Inscription
            </div>

            <!-- Formulaire d'inscription -->
            <v-form
              v-if="!isLoading"
              v-model="isValid"
            >
              <v-text-field
                v-model="prenom"
                color="secondary"
                label="Prénom... (optionnel)"
                hide-details="auto"
                prepend-icon="mdi-account"
              />

              <v-text-field
                v-model="email"
                color="secondary"
                label="Email..."
                :rules="[rules.required, rules.email]"
                hide-details="auto"
                hint="example@happyquest.fr"
                prepend-icon="mdi-at"
                required
              />

              <v-text-field
                v-model="password"
                color="secondary"
                label="Mot de passe..."
                :rules="[rules.required, rules.minLength]"
                type="password"
                hide-details="auto"
                prepend-icon="mdi-lock"
                required
              />

              <v-text-field
                v-model="passwordCheck"
                color="secondary"
                label="Vérification du mot de passe..."
                :rules="[rules.required, rules.pwdMatch]"
                type="password"
                hide-details="auto"
                prepend-icon="mdi-lock"
                required
              />

              <v-text-field
                v-model="code"
                color="secondary"
                label="Code entreprise..."
                :rules="[rules.required, rules.code]"
                prepend-icon="mdi-account-group"
                required
              />

              <v-checkbox
                v-model="newsletter"
                color="secondary"
                label="J'accepte de recevoir la newsletter"
                type="checkbox"
                hide-details="auto"
                prepend-icon="mdi-email-newsletter"
              />

              <v-checkbox
                v-model="cgu"
                color="secondary"
                type="checkbox"
                prepend-icon="mdi-file-document-edit"
              >
                <span slot="label">
                  J'accepte les
                  <b @click="handleCGU($event)">CGU</b>
                </span>
              </v-checkbox>

              <p
                v-if="error.hasError"
                class="title text-uppercase error--text"
              >
                {{ error.errorMsg }}
              </p>

              <div class="my-2">
                <v-btn
                  class="ma-2"
                  outlined
                  color="primary"
                  :disabled="!isValid"
                  @click="handleFormSubmit"
                >
                  Créer un compte
                  <v-icon right>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </div>
            </v-form>
            <v-row
              v-else
              justify="center"
            >
              <circle10 />
            </v-row>
            <!-- Retour à la page login
            <v-btn
              class="ma-2"
              text
              color="primary"
              @click="handleLogin"
            >
              Se connecter
            </v-btn>
            -->
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import Cgu from './Cgu.vue'
  import { Circle10 } from 'vue-loading-spinner'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'Register',

    /* Sous-composants utilisés par ce composant */
    components: {
      Cgu,
      Circle10,
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        prenom: '',
        email: '',
        password: '',
        passwordCheck: '',
        code: '',
        newsletter: false,
        cgu: false,
        isValid: false,
        isLoading: false,
        displayCGU: false,
        error: {
          hasError: false,
          errorMsg: '',
        },
        rules: {
          minLength: value => (value.length >= 4) || 'Ce champ contient 4 caractères minimum.',
          required: value => !!value || 'Ce champ ne peut être vide.',
          email: value => !!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) || 'Email invalide.',
          pwdMatch: value => value === this.password || 'Les mots de passe doivent être identiques.',
          code: value => !!value.match(/^[^<>'"/;`%?!&]*$/i) || 'Code invalide.',
        },
      }
    },

    /* Fonctions internes */
    methods: {
      // Création du compte
      handleFormSubmit: function () {
        this.isLoading = true
        this.$Auth.register(
          this.email,
          this.password,
          this.code,
          this.newsletter ? 1 : 0,
        )
          .then(res => {
            this.$router.push({
              name: 'Login',
              params: {
                displaySnackMsg: true,
                snackMsg: 'Ton inscription a été un succès ! Tu peux désormais te connecter avec tes identifiants.',
              },
            })
          })
          .catch(err => {
            this.error.hasError = true
            this.error.errorMsg = err.response.data
            this.password = ''
            this.passwordCheck = ''
          }).finally(() => {
            this.isLoading = false
          })
      },

      // Retour vers la page de Login
      handleLogin: function () {
        this.$router.push({ name: 'Login' })
      },

      // Affichage des CGU
      handleCGU: function () {
        this.displayCGU = true
        /* Le clic sur le label déclenche l'inversion de la valeur de la checkbox
        L'événement @click est executé avant le réel changement de la valeur
        On inverse donc la valeur afin qu'elle soit inversée de nouveau pour
        garantir sa constance lors du clic sur CGU */
        this.cgu = !this.cgu
      },
    },
  }
</script>
